<template>
  <div class="ding-overseas">
    <!-- <div class="ding-overseas-tit">询比价流程</div> -->
    <!-- <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/hwb_bg@2x.jpg" alt=""> -->
    <div class="ding-overseas-btn">
      <el-button type="primary" @click="toDingServer()">Contact Us</el-button>
    </div>
    
  </div>
</template>
<script>
  export default {
    props: [],
    data () {
      
      return {
        toastType:'',
        toastShow:false,
        timer:null
      }
    },
    components: {
      
    },
    created () {
      
    },
    computed:{
    },
    mounted () {

    },
    methods: {
      
      
      toDingServer(){
        window.open(`dingtalk://dingtalkclient/action/sendmsg?spm=a1z2e.8089787.content.dingtalk.7c364f9bXj6c9i&dingtalk_id=gjtu6k6`,'_blank')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/dingWorkbench/overseas.vue